import React from "react";
import error from "../assets/error.jpg";

const PageNotFound = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <div className="flex justify-center text-center mb-10 font-serif text-3xl font-bold text-slate-800 space-x-20">
          <div className="">
            <img className="w-64 rounded-full" src={error} alt="404 Error" loading="lazy" decoding="async" />
          </div>
          <div className="flex flex-col mt-16">
            <div className="mb-5 dark:text-slate-100">
              <h1>404 Error</h1>
              <h3>Page Not Found</h3>
            </div>
            <div className="">
              <a href="https://subhadipdas.innovexdev.com">
                <button className="bg-purple-700 rounded-xl px-2 py-2 text-slate-100 text-lg mx-10">
                  Go To Home
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
